module.exports = __webpack_public_path__ + "2141117606b8a6a5802324280869d4dc.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Bold.ttf
// module id = 406
// module chunks = 0